import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "grupo-pendencias"
  }, [_c('div', {
    staticClass: "card card-custom mb-6"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-6"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "to": {
        name: 'grupoEmpresa'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-1"
  }), _vm._v(" Voltar ao grupo ")])], 1)]), _c('div', {
    staticClass: "card-body pt-4"
  }, [_vm.carregandoInicial ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : _vm.grupo ? [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.carregarPendencias.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('b-form-group', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Vencimentos até",
      "label-for": "pendencias-vencimento"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "pendencias-vencimento",
      "options": _vm.opcoesDiasVencimento
    },
    model: {
      value: _vm.filtros.dias_vencimento,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "dias_vencimento", $$v);
      },
      expression: "filtros.dias_vencimento"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Certificados até",
      "label-for": "pendencias-certificado"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "pendencias-certificado",
      "options": _vm.opcoesDiasCertificado
    },
    model: {
      value: _vm.filtros.dias_certificado,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "dias_certificado", $$v);
      },
      expression: "filtros.dias_certificado"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Sem movimento há",
      "label-for": "pendencias-movimento"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "pendencias-movimento",
      "options": _vm.opcoesDiasSemMovimento
    },
    model: {
      value: _vm.filtros.dias_sem_movimento,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "dias_sem_movimento", $$v);
      },
      expression: "filtros.dias_sem_movimento"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Ação",
      "label-class": "invisible"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block d-flex align-items-center justify-content-center",
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando,
      "data-testid": "atualizar-pendencias"
    }
  }, [_vm.carregando ? _c('span', {
    staticClass: "spinner spinner-sm spinner-light mr-2"
  }) : _vm._e(), _vm._v(" Atualizar central ")])])], 1)]), _vm.carregando ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : _vm.central ? [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.cards, function (card) {
    return _c('div', {
      key: card.key,
      staticClass: "col-sm-6 col-xl-3 mb-5"
    }, [_c('div', {
      staticClass: "card card-custom h-100 border"
    }, [_c('div', {
      staticClass: "card-body p-5"
    }, [_c('span', {
      staticClass: "text-muted font-weight-bold d-block mb-2"
    }, [_vm._v(" " + _vm._s(card.label) + " ")]), _c('strong', {
      staticClass: "font-size-h2",
      class: card.className
    }, [_vm._v(" " + _vm._s(card.valor) + " ")])])])]);
  }), 0), _c('div', {
    staticClass: "card card-custom border mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row align-items-end mb-2"
  }, [_c('b-form-group', {
    staticClass: "col-lg-4",
    attrs: {
      "label": "Buscar empresa ou pendência",
      "label-for": "pendencias-busca"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pendencias-busca",
      "placeholder": "Digite para buscar"
    },
    model: {
      value: _vm.filtrosLocais.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosLocais, "busca", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "filtrosLocais.busca"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-3",
    attrs: {
      "label": "Prioridade",
      "label-for": "pendencias-prioridade"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "pendencias-prioridade",
      "options": _vm.opcoesSeveridade
    },
    model: {
      value: _vm.filtrosLocais.severidade,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosLocais, "severidade", $$v);
      },
      expression: "filtrosLocais.severidade"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-3",
    attrs: {
      "label": "Área",
      "label-for": "pendencias-categoria"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "pendencias-categoria",
      "options": _vm.opcoesCategoria
    },
    model: {
      value: _vm.filtrosLocais.categoria,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosLocais, "categoria", $$v);
      },
      expression: "filtrosLocais.categoria"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-2",
    attrs: {
      "label": "Ação",
      "label-class": "invisible"
    }
  }, [_c('button', {
    staticClass: "btn btn-light btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltrosLocais
    }
  }, [_vm._v(" Limpar filtros ")])])], 1), _vm.pendenciasFiltradas.length ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center mb-0"
  }, [_vm._m(1), _c('tbody', _vm._l(_vm.pendenciasFiltradas, function (pendencia) {
    return _c('tr', {
      key: pendencia.id
    }, [_c('td', [_c('span', {
      staticClass: "label label-inline",
      class: _vm.classeSeveridade(pendencia.severidade)
    }, [_vm._v(" " + _vm._s(_vm.labelSeveridade(pendencia.severidade)) + " ")])]), _c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(_vm.nomeEmpresa(pendencia.empresa)) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(pendencia.empresa && pendencia.empresa.tipo) + " ")])]), _c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(pendencia.titulo) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(pendencia.descricao) + " ")])]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatarData(pendencia.data_referencia)) + " ")]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatarValor(pendencia.valor)) + " ")]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.trocandoEmpresa || _vm.empresaAtualId === Number(pendencia.id_empresa)
      },
      on: {
        "click": function click($event) {
          return _vm.acessarEmpresa(pendencia);
        }
      }
    }, [_vm.trocandoEmpresaId === Number(pendencia.id_empresa) ? _c('span', {
      staticClass: "spinner spinner-sm spinner-primary mr-2"
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.empresaAtualId === Number(pendencia.id_empresa) ? "Empresa atual" : "Acessar empresa") + " ")])])]);
  }), 0)])]) : _c('div', {
    staticClass: "alert alert-light-success mb-0"
  }, [_vm._v(" Nenhuma pendência encontrada para os filtros selecionados. ")])])])] : _vm._e()] : _c('div', {
    staticClass: "alert alert-light-warning mb-0"
  }, [_vm._v(" Configure um grupo empresarial antes de consultar as pendências. ")])], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('div', [_c('h3', {
    staticClass: "card-label mb-1"
  }, [_vm._v("Central de pendências")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" O que precisa de ação nas empresas do grupo. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Prioridade")]), _c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Pendência")]), _c('th', [_vm._v("Referência")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ação")])])]);
}];
export { render, staticRenderFns };